/**
 * "Há quanto tempo", no formato curto que as listas usam.
 *
 * Existia uma cópia no Atendimento e outra na fila de comentários, com
 * espaçamento diferente ("30min" contra "30 min") — a mesma informação com duas
 * caras dependendo da tela.
 */
export function tempoRelativo(data: Date | string | null | undefined): string {
  if (!data) return "";
  const d = typeof data === "string" ? new Date(data) : data;
  if (Number.isNaN(d.getTime())) return "";

  const mins = Math.floor((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return "agora";
  if (mins < 60) return `${mins}min`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  // Passado de um dia, a data é mais útil que a contagem.
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
}
